import { render, staticRenderFns } from "./OsmEmissaoNova.vue?vue&type=template&id=e869a72a&scoped=true&lang=pug&"
import script from "./OsmEmissaoNova.vue?vue&type=script&lang=js&"
export * from "./OsmEmissaoNova.vue?vue&type=script&lang=js&"
import style0 from "./OsmEmissaoNova.vue?vue&type=style&index=0&id=e869a72a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e869a72a",
  null
  
)

export default component.exports